var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconStore = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5698",
  "data-name": "Caminho 5698",
  d: "M300.626-19.14c-.692-1.632-1.5-3.529-2.328-5.366a1,1,0,0,0-.732-.563c-3.526-.031-7.1-.03-10.642,0a.932.932,0,0,0-.7.51c-.7,1.563-1.432,3.248-2.366,5.465a1.1,1.1,0,0,0,.014.992.748.748,0,0,0,.616.374c.084.005.168.006.253.006v5.542a3.076,3.076,0,0,0,.976,2.388,3.067,3.067,0,0,0,2.13.689h3.339v-5.09h2.133v2.68l-.007,2.4h3.364a2.868,2.868,0,0,0,.294.016,2.726,2.726,0,0,0,1.76-.649,2.911,2.911,0,0,0,1.019-1.95,3,3,0,0,0,.011-.449v-5.592c.08,0,.167,0,.245,0a.758.758,0,0,0,.625-.372A1.161,1.161,0,0,0,300.626-19.14Zm-14.662-1.13c.427-1,.83-1.936,1.242-2.861a.339.339,0,0,1,.281-.153h0c3.155-.009,6.355-.009,9.509,0a.374.374,0,0,1,.3.17c.4.878.775,1.757,1.175,2.687l.359.833H285.673Zm10.72,9.606H294.65v-4.556c0-.374-.172-.526-.593-.527h-3.613c-.416,0-.593.159-.593.531v4.555h-2c-1.19,0-1.769-.5-1.77-1.517V-17.83l12.342-.006v5.694C298.421-10.923,297.476-10.666,296.684-10.664Z",
  transform: "translate(-283.748 25.092)",
  fill: "#fff"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconStore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_store.e2611b6f.svg";
export { ForwardRef as ReactComponent };